import React from 'react';

import './logo.css';

function Logo() {
  return (
    <div className="logo">
      <svg
        width="119px"
        height="48px"
        viewBox="0 0 119 48"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>smhi-logo</title>
        <g id="New-Navigation" stroke="none" strokeWidth="1" fillRule="evenodd">
          <g
            id="XL"
            transform="translate(-32.000000, -32.000000)"
            fillRule="nonzero"
          >
            <g id="smhi-logo" transform="translate(32.000000, 32.000000)">
              <path
                d="M57.6530325,46.9927976 L55.5921322,26.764493 L51.732628,46.9927976 L41.4655976,46.9927976 L37.3063261,27.1765511 L35.0206004,46.9553378 L21.1188912,46.9553378 L21.8308386,43.096976 C17.9338635,47.8918334 12.3506973,48.4537307 6.2054674,47.554695 C3.58250341,46.9553378 0.285062972,45.4569448 0.285062972,45.4569448 L0.285062972,31.9714085 C2.38343416,34.5186765 5.75581643,37.5154623 9.80267516,36.0170694 C11.0017444,35.3802524 12.7628774,32.5333058 10.327268,30.9225334 C6.31788014,27.7759083 1.55907405,24.6292831 0.247592058,18.2611132 C-0.689180795,12.6046799 1.03448125,7.39776442 5.38110729,3.5019428 C10.0275006,-0.244039526 17.9713344,0.505156939 22.9174951,3.20226421 L22.9174951,16.6878006 C20.8940657,14.8522692 19.02052,12.6421397 16.1727306,12.4923004 C15.123545,12.4923004 13.4748247,12.6421397 12.8752901,13.9906933 C11.8261045,16.9874792 15.4233123,18.5982516 17.3717998,19.984265 C19.8448801,21.7448767 22.4303732,24.1797652 23.816797,26.7270332 L27.2641211,1.70387128 L41.4281267,1.70387128 L46.4492292,19.6845864 L51.6576862,1.70387128 L65.8591627,1.70387128 L70.4680851,46.9553378 L57.6530325,46.9553378 L57.6530325,46.9927976 Z"
                id="Path"
              ></path>
              <polygon
                id="Path"
                points="70.4680851 46.8904649 70.4680851 0.933018125 83.8959811 0.933018125 83.8959811 16.6452909 88.8510638 16.6452909 88.8510638 0.933018125 102.12766 0.933018125 102.089835 46.8904649 88.8510638 46.8904649 88.8510638 28.7433605 83.8959811 28.7433605 83.8959811 46.8904649 83.8959811 46.8904649"
              ></polygon>
              <polygon
                id="Path"
                points="118.468085 0.933018125 118.468085 46.8904649 106.212766 46.8904649 106.212766 0.933018125"
              ></polygon>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default Logo;
